import React from 'react';
import Icon from '../../../components/appIcon';

const WelcomeSection = ({ employee, todayAttendance }) => {
  const getCurrentTime = () => {
    return new Date()?.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'present':
        return 'text-success bg-success/10 border-success/20';
      case 'late':
        return 'text-warning bg-warning/10 border-warning/20';
      case 'absent':
        return 'text-error bg-error/10 border-error/20';
      case 'not_checked_in':
        return 'text-muted-foreground bg-muted border-border';
      default:
        return 'text-muted-foreground bg-muted border-border';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'present':
        return 'CheckCircle';
      case 'late':
        return 'Clock';
      case 'absent':
        return 'XCircle';
      case 'not_checked_in':
        return 'Circle';
      default:
        return 'Circle';
    }
  };

  const formatTime = (timeString) => {
    if (!timeString) return '--:--';
    const time = new Date(timeString);
    return time?.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 enterprise-shadow-card">
      <div className="flex items-start justify-between mb-6">
        <div>
          <h1 className="text-2xl font-semibold text-foreground mb-2">
            Welcome back, {employee?.first_name} {employee?.last_name}!
          </h1>
          <p className="text-muted-foreground">
            Today is {new Date()?.toLocaleDateString('en-US', { 
              weekday: 'long', 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
          <p className="text-sm text-muted-foreground">Current time: {getCurrentTime()}</p>
        </div>
        <div className="text-right">
          <div className={`inline-flex items-center space-x-2 px-3 py-2 rounded-full border text-sm font-medium ${getStatusColor(todayAttendance?.status)}`}>
            <Icon name={getStatusIcon(todayAttendance?.status)} size={16} />
            <span className="capitalize">
              {todayAttendance?.status === 'not_checked_in' ? 'Not Checked In' : todayAttendance?.status?.replace('_', ' ')}
            </span>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-10 h-10 bg-success/10 rounded-lg">
              <Icon name="LogIn" size={20} className="text-success" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Check In</p>
              <p className="text-lg font-semibold text-foreground">
                {formatTime(todayAttendance?.checkIn)}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-10 h-10 bg-error/10 rounded-lg">
              <Icon name="LogOut" size={20} className="text-error" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Check Out</p>
              <p className="text-lg font-semibold text-foreground">
                {formatTime(todayAttendance?.checkOut)}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
              <Icon name="Clock" size={20} className="text-primary" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Total Hours</p>
              <p className="text-lg font-semibold text-foreground">
                {todayAttendance?.totalHours || '0:00'}
              </p>
            </div>
          </div>
        </div>
      </div>
      {todayAttendance?.location && (
        <div className="mt-4 flex items-center space-x-2 text-sm text-muted-foreground">
          <Icon name="MapPin" size={16} />
          <span>Location: {todayAttendance?.location}</span>
        </div>
      )}
    </div>
  );
};

export default WelcomeSection;